var React = require('react');

function DocumentsInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}.cls-2{fill:none;}")),React.createElement("polygon",{"className":"cls-1","points":"24.96 13.94 24.96 28.27 13.61 28.27 13.61 28.99 25.69 28.99 25.7 14.68 24.96 13.94","key":1}),React.createElement("path",{"className":"cls-1","d":"M19.05,8H10.16V26.54H23.24V12.22Zm2.82,17.17H11.54V9.37h7.31v3.17h3Z","key":2}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":3})]);
}

DocumentsInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = DocumentsInline;

DocumentsInline.default = DocumentsInline;
